/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InvalidTokenRouteImport } from './routes/invalid-token'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as TokenRouteImport } from './routes/$token'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FaqVoloteaRouteImport } from './routes/faq/volotea'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as AuthenticatedPaymentRouteImport } from './routes/_authenticated/payment'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as LocaleFaqRouteImport } from './routes/$locale/faq'
import { Route as LocaleTokenRouteImport } from './routes/$locale.$token'
import { Route as AuthenticatedPaymentConfirmationRouteImport } from './routes/_authenticated/payment_.confirmation'
import { Route as LocaleFaqVoloteaRouteImport } from './routes/$locale/faq/volotea'
import { Route as AuthenticatedContractsContractIdClaimCancellationWithoutProofRouteImport } from './routes/_authenticated/contracts/$contractId/claim-cancellation-without-proof'
import { Route as AuthenticatedContractsContractIdClaimBaggageDisruptionRouteImport } from './routes/_authenticated/contracts/$contractId/claim-baggage-disruption'
import { Route as AuthenticatedContractsContractIdClaimRouteImport } from './routes/_authenticated/contracts/$contractId/claim'
import { Route as AuthenticatedContractsContractIdBaggageDisruptionRouteImport } from './routes/_authenticated/contracts/$contractId/baggage-disruption'

const InvalidTokenRoute = InvalidTokenRouteImport.update({
  id: '/invalid-token',
  path: '/invalid-token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const TokenRoute = TokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqVoloteaRoute = FaqVoloteaRouteImport.update({
  id: '/faq/volotea',
  path: '/faq/volotea',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const AuthenticatedPaymentRoute = AuthenticatedPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LocaleFaqRoute = LocaleFaqRouteImport.update({
  id: '/$locale/faq',
  path: '/$locale/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleTokenRoute = LocaleTokenRouteImport.update({
  id: '/$locale/$token',
  path: '/$locale/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedPaymentConfirmationRoute =
  AuthenticatedPaymentConfirmationRouteImport.update({
    id: '/payment_/confirmation',
    path: '/payment/confirmation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const LocaleFaqVoloteaRoute = LocaleFaqVoloteaRouteImport.update({
  id: '/volotea',
  path: '/volotea',
  getParentRoute: () => LocaleFaqRoute,
} as any)
const AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute =
  AuthenticatedContractsContractIdClaimCancellationWithoutProofRouteImport.update(
    {
      id: '/contracts/$contractId/claim-cancellation-without-proof',
      path: '/contracts/$contractId/claim-cancellation-without-proof',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedContractsContractIdClaimBaggageDisruptionRoute =
  AuthenticatedContractsContractIdClaimBaggageDisruptionRouteImport.update({
    id: '/contracts/$contractId/claim-baggage-disruption',
    path: '/contracts/$contractId/claim-baggage-disruption',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsContractIdClaimRoute =
  AuthenticatedContractsContractIdClaimRouteImport.update({
    id: '/contracts/$contractId/claim',
    path: '/contracts/$contractId/claim',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsContractIdBaggageDisruptionRoute =
  AuthenticatedContractsContractIdBaggageDisruptionRouteImport.update({
    id: '/contracts/$contractId/baggage-disruption',
    path: '/contracts/$contractId/baggage-disruption',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
  '/auth': typeof AuthRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/$locale/$token': typeof LocaleTokenRoute
  '/$locale/faq': typeof LocaleFaqRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/payment': typeof AuthenticatedPaymentRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/faq/volotea': typeof FaqVoloteaRoute
  '/$locale/faq/volotea': typeof LocaleFaqVoloteaRoute
  '/payment/confirmation': typeof AuthenticatedPaymentConfirmationRoute
  '/contracts/$contractId/baggage-disruption': typeof AuthenticatedContractsContractIdBaggageDisruptionRoute
  '/contracts/$contractId/claim': typeof AuthenticatedContractsContractIdClaimRoute
  '/contracts/$contractId/claim-baggage-disruption': typeof AuthenticatedContractsContractIdClaimBaggageDisruptionRoute
  '/contracts/$contractId/claim-cancellation-without-proof': typeof AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
  '/auth': typeof AuthRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/$locale/$token': typeof LocaleTokenRoute
  '/$locale/faq': typeof LocaleFaqRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/payment': typeof AuthenticatedPaymentRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/faq/volotea': typeof FaqVoloteaRoute
  '/$locale/faq/volotea': typeof LocaleFaqVoloteaRoute
  '/payment/confirmation': typeof AuthenticatedPaymentConfirmationRoute
  '/contracts/$contractId/baggage-disruption': typeof AuthenticatedContractsContractIdBaggageDisruptionRoute
  '/contracts/$contractId/claim': typeof AuthenticatedContractsContractIdClaimRoute
  '/contracts/$contractId/claim-baggage-disruption': typeof AuthenticatedContractsContractIdClaimBaggageDisruptionRoute
  '/contracts/$contractId/claim-cancellation-without-proof': typeof AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/auth': typeof AuthRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/$locale/$token': typeof LocaleTokenRoute
  '/$locale/faq': typeof LocaleFaqRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/payment': typeof AuthenticatedPaymentRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/faq/volotea': typeof FaqVoloteaRoute
  '/$locale/faq/volotea': typeof LocaleFaqVoloteaRoute
  '/_authenticated/payment_/confirmation': typeof AuthenticatedPaymentConfirmationRoute
  '/_authenticated/contracts/$contractId/baggage-disruption': typeof AuthenticatedContractsContractIdBaggageDisruptionRoute
  '/_authenticated/contracts/$contractId/claim': typeof AuthenticatedContractsContractIdClaimRoute
  '/_authenticated/contracts/$contractId/claim-baggage-disruption': typeof AuthenticatedContractsContractIdClaimBaggageDisruptionRoute
  '/_authenticated/contracts/$contractId/claim-cancellation-without-proof': typeof AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$token'
    | '/auth'
    | '/invalid-token'
    | '/$locale/$token'
    | '/$locale/faq'
    | '/home'
    | '/payment'
    | '/login'
    | '/faq/volotea'
    | '/$locale/faq/volotea'
    | '/payment/confirmation'
    | '/contracts/$contractId/baggage-disruption'
    | '/contracts/$contractId/claim'
    | '/contracts/$contractId/claim-baggage-disruption'
    | '/contracts/$contractId/claim-cancellation-without-proof'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$token'
    | '/auth'
    | '/invalid-token'
    | '/$locale/$token'
    | '/$locale/faq'
    | '/home'
    | '/payment'
    | '/login'
    | '/faq/volotea'
    | '/$locale/faq/volotea'
    | '/payment/confirmation'
    | '/contracts/$contractId/baggage-disruption'
    | '/contracts/$contractId/claim'
    | '/contracts/$contractId/claim-baggage-disruption'
    | '/contracts/$contractId/claim-cancellation-without-proof'
  id:
    | '__root__'
    | '/'
    | '/$token'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/auth'
    | '/invalid-token'
    | '/$locale/$token'
    | '/$locale/faq'
    | '/_authenticated/home'
    | '/_authenticated/payment'
    | '/_unauthenticated/login'
    | '/faq/volotea'
    | '/$locale/faq/volotea'
    | '/_authenticated/payment_/confirmation'
    | '/_authenticated/contracts/$contractId/baggage-disruption'
    | '/_authenticated/contracts/$contractId/claim'
    | '/_authenticated/contracts/$contractId/claim-baggage-disruption'
    | '/_authenticated/contracts/$contractId/claim-cancellation-without-proof'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TokenRoute: typeof TokenRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  AuthRoute: typeof AuthRoute
  InvalidTokenRoute: typeof InvalidTokenRoute
  LocaleTokenRoute: typeof LocaleTokenRoute
  LocaleFaqRoute: typeof LocaleFaqRouteWithChildren
  FaqVoloteaRoute: typeof FaqVoloteaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/invalid-token': {
      id: '/invalid-token'
      path: '/invalid-token'
      fullPath: '/invalid-token'
      preLoaderRoute: typeof InvalidTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$token': {
      id: '/$token'
      path: '/$token'
      fullPath: '/$token'
      preLoaderRoute: typeof TokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/volotea': {
      id: '/faq/volotea'
      path: '/faq/volotea'
      fullPath: '/faq/volotea'
      preLoaderRoute: typeof FaqVoloteaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/payment': {
      id: '/_authenticated/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof AuthenticatedPaymentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/$locale/faq': {
      id: '/$locale/faq'
      path: '/$locale/faq'
      fullPath: '/$locale/faq'
      preLoaderRoute: typeof LocaleFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$token': {
      id: '/$locale/$token'
      path: '/$locale/$token'
      fullPath: '/$locale/$token'
      preLoaderRoute: typeof LocaleTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/payment_/confirmation': {
      id: '/_authenticated/payment_/confirmation'
      path: '/payment/confirmation'
      fullPath: '/payment/confirmation'
      preLoaderRoute: typeof AuthenticatedPaymentConfirmationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/$locale/faq/volotea': {
      id: '/$locale/faq/volotea'
      path: '/volotea'
      fullPath: '/$locale/faq/volotea'
      preLoaderRoute: typeof LocaleFaqVoloteaRouteImport
      parentRoute: typeof LocaleFaqRoute
    }
    '/_authenticated/contracts/$contractId/claim-cancellation-without-proof': {
      id: '/_authenticated/contracts/$contractId/claim-cancellation-without-proof'
      path: '/contracts/$contractId/claim-cancellation-without-proof'
      fullPath: '/contracts/$contractId/claim-cancellation-without-proof'
      preLoaderRoute: typeof AuthenticatedContractsContractIdClaimCancellationWithoutProofRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/$contractId/claim-baggage-disruption': {
      id: '/_authenticated/contracts/$contractId/claim-baggage-disruption'
      path: '/contracts/$contractId/claim-baggage-disruption'
      fullPath: '/contracts/$contractId/claim-baggage-disruption'
      preLoaderRoute: typeof AuthenticatedContractsContractIdClaimBaggageDisruptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/$contractId/claim': {
      id: '/_authenticated/contracts/$contractId/claim'
      path: '/contracts/$contractId/claim'
      fullPath: '/contracts/$contractId/claim'
      preLoaderRoute: typeof AuthenticatedContractsContractIdClaimRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/$contractId/baggage-disruption': {
      id: '/_authenticated/contracts/$contractId/baggage-disruption'
      path: '/contracts/$contractId/baggage-disruption'
      fullPath: '/contracts/$contractId/baggage-disruption'
      preLoaderRoute: typeof AuthenticatedContractsContractIdBaggageDisruptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedPaymentRoute: typeof AuthenticatedPaymentRoute
  AuthenticatedPaymentConfirmationRoute: typeof AuthenticatedPaymentConfirmationRoute
  AuthenticatedContractsContractIdBaggageDisruptionRoute: typeof AuthenticatedContractsContractIdBaggageDisruptionRoute
  AuthenticatedContractsContractIdClaimRoute: typeof AuthenticatedContractsContractIdClaimRoute
  AuthenticatedContractsContractIdClaimBaggageDisruptionRoute: typeof AuthenticatedContractsContractIdClaimBaggageDisruptionRoute
  AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute: typeof AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedPaymentRoute: AuthenticatedPaymentRoute,
  AuthenticatedPaymentConfirmationRoute: AuthenticatedPaymentConfirmationRoute,
  AuthenticatedContractsContractIdBaggageDisruptionRoute:
    AuthenticatedContractsContractIdBaggageDisruptionRoute,
  AuthenticatedContractsContractIdClaimRoute:
    AuthenticatedContractsContractIdClaimRoute,
  AuthenticatedContractsContractIdClaimBaggageDisruptionRoute:
    AuthenticatedContractsContractIdClaimBaggageDisruptionRoute,
  AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute:
    AuthenticatedContractsContractIdClaimCancellationWithoutProofRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

interface LocaleFaqRouteChildren {
  LocaleFaqVoloteaRoute: typeof LocaleFaqVoloteaRoute
}

const LocaleFaqRouteChildren: LocaleFaqRouteChildren = {
  LocaleFaqVoloteaRoute: LocaleFaqVoloteaRoute,
}

const LocaleFaqRouteWithChildren = LocaleFaqRoute._addFileChildren(
  LocaleFaqRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TokenRoute: TokenRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  AuthRoute: AuthRoute,
  InvalidTokenRoute: InvalidTokenRoute,
  LocaleTokenRoute: LocaleTokenRoute,
  LocaleFaqRoute: LocaleFaqRouteWithChildren,
  FaqVoloteaRoute: FaqVoloteaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
